import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reduxForm, Field} from 'redux-form'
import {handleCreateDialog, setDialogs} from '../../modules/support'
import {hideModal, CREATE_DIALOG} from '../../modules/modals'
import {required} from '../common/Form/rules'


class CreateDialogForm extends Component {
    static contextTypes = {
        formatMessage: PropTypes.any
    }
    render() {
        let {handleSubmit, error, submitting, hideModal} = this.props
        const {formatMessage} = this.context
        return (
            <form className="create-dialog-form" onSubmit={handleSubmit}>
                <Field
                    name = "name"
                    component = {this.RenderInput}
                    validate = {[required]}
                    ref = {this.getFieldRef}
                />
                <Field
                    name = "question"
                    component = {this.RenderTextarea}
                    validate = {[required]}
                />
                {
                    error &&
                    <div className="create-dialog-form__group">
                        <p style={{color:"red"}}>{error}</p>
                    </div>
                }
                <div className="create-dialog-form__group flex flex-center">
                    <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={submitting}
                    >{formatMessage("Create")}</button>
                    <button
                        className="btn btn-warning"
                        type="button"
                        onClick={()=>hideModal({ modalType : CREATE_DIALOG})}
                        disabled={submitting}
                    >{formatMessage("Cancel")}</button>
                </div>
            </form>
        )
    }
    RenderInput = ({input, meta : {touched, error}}) => (
        <div className="create-dialog-form__group">
            <label htmlFor="name">{this.context.formatMessage("Request name")}</label>
            <input
                {...input}
                id="name"
                className="create-dialog-form__control"
                type="text"
            />
            {
                touched && error && <span style={{color:"red"}}>{error}</span>
            }
        </div>
    )
    RenderTextarea = ({input, meta : {touched, error}}) => (
        <div className="create-dialog-form__group">
        <textarea
            {...input}
            className="create-dialog-form__control"
            placeholder={`${this.context.formatMessage("What problem do you have?")}`}
        ></textarea>
            {
                touched && error && <span style={{color:"red"}}>{error}</span>
            }
        </div>
    )
    getFieldRef = ref => {
        if (ref) this.input = findDOMNode(ref).querySelector('input')
    }
    componentDidMount() {
        this.setFocus()
    }
    setFocus = () => this.input && this.input.focus()
}

export default connect(
    null,
    {hideModal},
    null,
    {pure : false}
)(reduxForm({
    form: 'createDialog',
    onSubmit : (values, dispatch, props) => {
        return handleCreateDialog({
            name : values.name,
            question : values.question
        })
        .then(updateData => {
            // dispatch(setDialogs({dialogs:[updateData]}))
            dispatch(hideModal({modalType : CREATE_DIALOG}))
            props.onLoaded();
        })
    },
})(CreateDialogForm))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/CreateDialogForm.js